import useRipple from '@hooks/useRipple'
// Implementation of the button component from the Furry Design System

import { HTMLAttributes, memo } from 'react'

interface FurryButtonProps extends HTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  error?: boolean
  fullWidth?: boolean
  ripple?: boolean
  disabled?: boolean
  type?: 'submit' | 'reset' | 'button'
}

function FurryButton({
  size = 'md',
  fullWidth,
  ripple,
  disabled,
  className,
  type,
  ...rest
}: FurryButtonProps) {
  const classes = [
    'text-[white]',
    'border',
    'border-solid',
    'font-medium',
    'rounded-2xl',
    'border-[rgb(53,59,64)]',
    'bg-[rgb(35,38,42)]',
    'transition',
    'relative',
    'overflow-hidden',
  ]

  if (disabled) {
    classes.push('opacity-50', 'cursor-default')
  } else {
    classes.push(
      'hover:bg-[rgb(26,27,30)]',
      'hover:opacity-80',
      'active:opacity-80',
      'active:bg-[rgb(53,59,64)]',
    )
  }

  switch (size) {
    case 'sm':
      classes.push('py-2', 'px-3', 'text-xs', 'xs:text-sm')
      break
    case 'lg':
      classes.push('py-3', 'px-5', 'text-xs', 'xs:text-sm')
      break
    case 'xl':
      classes.push('py-3', 'px-5', 'text-sm', 'xs:text-base')
      break
    case 'md':
    default:
      classes.push('py-2.5', 'px-3.5', 'text-xs', 'xs:text-sm')
      break
  }

  if (fullWidth) {
    classes.push('w-full')
  } else {
    classes.push('w-fit')
  }

  if (className) {
    classes.push(className)
  }

  // TODO: Fix this
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const rippleRef = ripple ? useRipple<HTMLButtonElement>({}) : undefined

  return (
    <button
      type={type}
      ref={rippleRef}
      {...rest}
      className={classes.join(' ')}
    />
  )
}

export default memo(FurryButton)
